import React from 'react';
import { motion } from 'framer-motion';
import { QrCode, Check, MapPin } from 'lucide-react';
export function CheckInPreview() {
  return <section className="py-24 bg-white" data-id="element-48">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-49">
        <div className="flex flex-col lg:flex-row-reverse items-center gap-16" data-id="element-50">
          <div className="lg:w-1/2" data-id="element-51">
            <motion.div initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} data-id="element-52">
              <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-6" data-id="element-53">
                Seamless Member Experience
              </h2>
              <p className="text-lg text-slate-600 mb-8 leading-relaxed" data-id="element-54">
                No more paper logs or complex portals. Members simply scan a QR
                code at their gym to verify eligibility and log their visit
                instantly.
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-55">
                {[{
                title: 'Instant Access',
                desc: 'Digital ID card always available on their phone.'
              }, {
                title: 'Location Verified',
                desc: 'GPS verification ensures valid facility visits.'
              }, {
                title: 'Progress Tracking',
                desc: 'Members can see their visit count in real-time.'
              }, {
                title: 'Universal Support',
                desc: 'Works with thousands of fitness locations.'
              }].map((feature, i) => <div key={i} className="flex flex-col gap-2" data-id="element-56">
                    <h3 className="font-bold text-slate-900" data-id="element-57">
                      {feature.title}
                    </h3>
                    <p className="text-sm text-slate-600" data-id="element-58">{feature.desc}</p>
                  </div>)}
              </div>
            </motion.div>
          </div>

          <div className="lg:w-1/2 w-full flex justify-center" data-id="element-59">
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="relative w-[300px] h-[600px] bg-slate-900 rounded-[3rem] p-4 shadow-2xl border-8 border-slate-900" data-id="element-60">
              {/* Phone Screen Mock */}
              <div className="w-full h-full bg-white rounded-[2rem] overflow-hidden relative flex flex-col" data-id="element-61">
                {/* Status Bar */}
                <div className="h-8 bg-white w-full flex justify-between items-center px-6 pt-2" data-id="element-62">
                  <div className="text-xs font-bold" data-id="element-63">9:41</div>
                  <div className="flex gap-1" data-id="element-64">
                    <div className="w-4 h-2.5 bg-black rounded-sm" data-id="element-65"></div>
                  </div>
                </div>

                {/* App Content */}
                <div className="flex-1 p-6 flex flex-col items-center pt-12" data-id="element-66">
                  <div className="w-16 h-16 rounded-full bg-orange-100 flex items-center justify-center mb-4" data-id="element-67">
                    <div className="w-12 h-12 rounded-full bg-[#FF6B35] flex items-center justify-center text-white font-bold text-xl" data-id="element-68">
                      JD
                    </div>
                  </div>
                  <h3 className="text-xl font-bold text-slate-900 mb-1" data-id="element-69">
                    John Doe
                  </h3>
                  <p className="text-sm text-slate-500 mb-8" data-id="element-70">
                    Active Member • Gold Plan
                  </p>

                  <div className="w-full bg-slate-50 rounded-2xl p-6 mb-8 border border-slate-100 flex flex-col items-center" data-id="element-71">
                    <QrCode className="w-32 h-32 text-slate-900 mb-4" data-id="element-72" />
                    <p className="text-xs text-slate-400 text-center" data-id="element-73">
                      Scan at front desk
                    </p>
                  </div>

                  <div className="w-full space-y-3" data-id="element-74">
                    <div className="flex items-center gap-3 p-3 rounded-xl bg-green-50 border border-green-100" data-id="element-75">
                      <div className="h-8 w-8 rounded-full bg-green-100 flex items-center justify-center" data-id="element-76">
                        <Check className="w-4 h-4 text-green-600" data-id="element-77" />
                      </div>
                      <div data-id="element-78">
                        <p className="text-sm font-bold text-slate-900" data-id="element-79">
                          Eligible
                        </p>
                        <p className="text-xs text-slate-500" data-id="element-80">
                          Verified just now
                        </p>
                      </div>
                    </div>

                    <div className="flex items-center gap-3 p-3 rounded-xl bg-slate-50 border border-slate-100" data-id="element-81">
                      <div className="h-8 w-8 rounded-full bg-slate-200 flex items-center justify-center" data-id="element-82">
                        <MapPin className="w-4 h-4 text-slate-600" data-id="element-83" />
                      </div>
                      <div data-id="element-84">
                        <p className="text-sm font-bold text-slate-900" data-id="element-85">
                          Fitness World
                        </p>
                        <p className="text-xs text-slate-500" data-id="element-86">
                          123 Main St, Austin
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Bottom Nav */}
                <div className="h-16 border-t border-slate-100 flex justify-around items-center px-4" data-id="element-87">
                  <div className="p-2 text-[#FF6B35]" data-id="element-88">
                    <QrCode className="w-6 h-6" data-id="element-89" />
                  </div>
                  <div className="p-2 text-slate-300" data-id="element-90">
                    <MapPin className="w-6 h-6" data-id="element-91" />
                  </div>
                  <div className="p-2 text-slate-300" data-id="element-92">
                    <div className="w-6 h-6 rounded-full border-2 border-current" data-id="element-93" />
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}